import React, { PropsWithChildren, ReactElement } from "react";
import styles from "./paymentOption.module.scss";

/**
 * handles border logics
 */
const Wrapper = (
  props: PropsWithChildren<React.InputHTMLAttributes<HTMLInputElement>>,
): ReactElement => {
  const { children, ...rest } = props;
  return (
    <>
      <input type="radio" className={styles.radio} {...rest} />
      <label className={styles.wrapper} htmlFor={props.id}>
        {props.children}
      </label>
    </>
  );
};

const Indicator = (): ReactElement => {
  return <div className={styles.indicator} />;
};

const Content = (props: PropsWithChildren): ReactElement => {
  return <div className={styles.content}>{props.children}</div>;
};

const SpaceBetweenRow = (props: PropsWithChildren): ReactElement => {
  return <div className={styles.spaceBetweenRow}>{props.children}</div>;
};

const PrimaryBadge = (props: PropsWithChildren): ReactElement => {
  return <div className={styles.primaryBadge}>{props.children}</div>;
};

const SecondaryBadge = (props: PropsWithChildren): ReactElement => {
  return <div className={styles.secondaryBadge}>{props.children}</div>;
};

const Badge = (props: PropsWithChildren<{ bgColor: string }>): ReactElement => {
  return (
    <div className={styles.badge} style={{ backgroundColor: props.bgColor }}>
      {props.children}
    </div>
  );
};

const DiagonalBadge = (
  props: PropsWithChildren<{ bgColor: string }>,
): ReactElement => {
  return (
    <div
      className={styles.diagonalBadge}
      style={{ backgroundColor: props.bgColor }}
    >
      {props.children}
    </div>
  );
};

export const PaymentOptions = {
  Wrapper,
  Indicator,
  Content,
  SpaceBetweenRow,
  PrimaryBadge,
  SecondaryBadge,
  Badge,
  DiagonalBadge,
};
